<template>
  <div class="for_programer">
    <v-container>
      <v-row>
        <v-col>
          <p class="text-md-h5 text-h6 text-center font-weight-bold">
            Подключайтесь к сообществу клуба Кубит!
          </p>
          <p
            class="text-caption text-md-subtitle-1 text-center text--secondary"
          >
            делитесь мыслями, учитесь, учите, помогайте, <br />
            делайте совместные проекты и общайтесь
          </p>
        </v-col>
      </v-row>
      <v-row v-for="(item, index) in toDo" :key="index">
        <v-col
          cols="12"
          md="4"
          class="text-md-h5 text-h6 what d-flex justify-center align-center"
        >
          {{ item.what }}
        </v-col>
        <v-col cols="12" md="8">
          <v-hover v-slot="{ hover }">
            <v-card
              class="pa-6 how"
              :elevation="hover ? 8 : 2"
              :id="item.index"
            >
              {{ item.how }}
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center col-12 col-md-6">
          <a href="tel:+79068970429"
            ><v-card-text> <b>Телефон:</b> 8 906 897-04-29 </v-card-text></a
          >
        </v-col>
        <v-col class="col-12 col-md-6 text-center">
          <a href="https://t.me/GrachevRV" target="_blank">
            <v-card-text>
              <v-icon large> mdi-telegram </v-icon> Telegram
            </v-card-text></a
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { gsap } from "gsap";
export default {
  data: () => ({
    toDo: [
      {
        what: "Преподавать?",
        how: " Последовательно, регулярно проводить занятия, передовая базовые знания технологий и необходимые навыки. Вести учеников до выполнения самостоятельного проекта.",
      },
      {
        what: "Вдохновлять?",
        how: " Провести лекцию, встречу, мотивационную беседу, поделится впечатлением или опытом.",
      },
      {
        what: "Делиться знаниями? ",
        how: " Прочитать лекцию, провести семинар, мастер-класс рассказать о технологии, продукте, научить чему-то.",
      },
      {
        what: "Менторить? ",
        how: "  Помогать, давать советы, вдохновлять, передавать ученику необходимые навыки и знания.",
      },
      {
        what: "Тестировать?",
        how: " Проверять свои идеи, продукты, тестировать на заинтересованной аудитории, получать критику и замечания.",
      },
      {
        what: "Привлекать?",
        how: " Искать помощников, исполнителей для выполнения работы, создания продукта.",
      },
      {
       
        what: "Создавать?",
        how: " Придумывать и соместно делать новый продукт, сервис, услугу. ",
      },
      {
     
        what: "Предлагать?",
        how: " Обсуждать новые идеи, продукты, искать единомышленников.",
      },
      {
       
        what: "Общаться?",
        how: " Встречаться, делится мыслями, эмоциями, новыми открытиями, знаниями и впечатлениями.",
      },
    ],
  }),
  mounted() {
  
    gsap.from(".how", {
      x: 200,     
      duration: 1,
    });
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}
.v-application a {
  color: rgba(0, 0, 0, 0.6);
}
.what {
  transform: scale(1);
  transition: transform 1s ease;
  &:hover {
    transform: scale(1.1);
    transition: transform 1s ease;
  }
}
.for_programer{
  overflow: hidden;
}
</style>